import axios from "axios";
import i18n from "../i18n";


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Add Accept-Language dynamically
axiosInstance.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = i18n.language;
  return config;
});

export const axiosPrivate = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export default axiosInstance;
